<template>
  <div style="text-align: left" class="regist">
    <div>
      <input hidden id="member" :value=teamMember />
      <el-row>
        <el-col :span="24">
          <el-form
            ref="form"
            align="center"
            :model="form"
            :rules="rules"
            :label-width="PcOrPhone == 'Phone' ? '' : labelWidth"
            v-if="dataWaitFalg"
          >
            <el-row class="regTypeTitle" v-if="form.status == '1'">
              <el-col :span="24" style="text-align: left">
                <!-- <el-button
                  type="info"
                  size="mini"
                  style="background: #0654ef; border-color: #0654ef"
                  >{{ dictData.dictLabel}}</el-button
                >
                <el-button
                  v-if="addStatus && dictData.number > '1'"
                  circle
                  icon="el-icon-plus"
                  size="mini"
                  style="margin-left: 10px"
                  @click="addForm"
                  type="primary"
                  :disabled="disabledFalg"
                ></el-button>
                <el-button
                  v-if="cutStatus && dictData.number > '1'"
                  circle
                  icon="el-icon-minus"
                  size="mini"
                  type="danger"
                  @click="cutForm"
                  :disabled="disabledFalg"
                ></el-button> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col
                style="text-align: left; padding-bottom: 10px"
                v-if="field.show"
                :span="12"
                :key="field.id"
                v-for="(field, index) in fieldNameOptions"
              >
                <el-form-item
                  v-if="field.show"
                  :label="field.labelName"
                  :prop="field.labelField"
                >
                  <el-input
                    :disabled="disabledFalg"
                    v-model="form[field.labelField]"
                    :placeholder="
                      field.remark ? field.remark : '请输入' + field.labelName
                    "
                    v-if="
                      field.fieldType == 'input' ||
                      field.fieldType == 'linkEmail' ||
                      field.fieldType == 'linkPhone'
                    "
                  />
                  <el-input
                    :disabled="disabledFalg"
                    type="textarea"
                    :rows="2"
                    :placeholder="
                      field.remark ? field.remark : '请输入' + field.labelName
                    "
                    v-model="form[field.labelField]"
                    v-if="field.fieldType == 'textarea'"
                  ></el-input>
                  <el-select
                    @change="$forceUpdate()"
                    filterable
                    :disabled="disabledFalg"
                    v-model="form[field.labelField]"
                    :placeholder="
                      field.remark ? field.remark : '请选择' + field.labelName
                    "
                    v-if="field.fieldType == 'select'"
                  >
                    <el-option
                      :key="dic.dictCode"
                      :label="dic.dictLabel"
                      :value="dic.dictValue"
                      v-for="dic in dictionaryDataMap.get(field.labelField)"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width:100%"
                    @change="changeDivision(form[field.labelField])"
                    filterable
                    :disabled="disabledFalg"
                    v-model="form[field.labelField]"
                    :placeholder="
                      field.remark ? field.remark : '请选择' + field.labelName
                    "
                    v-if="field.fieldType == 'division' && queryDivision"
                  >
                    <el-option
                      :key="division.id"
                      :label="division.name"
                      :value="division.id"
                      v-for="division in divisionList"
                    >
                    </el-option>
                  </el-select>
                  <el-radio
                    @change="number(dic)"
                    :disabled="dic.dictType == 'work_type' ? radioFalg : disabledFalg"
                    :key="dic.dictCode"
                    :label="dic.dictValue"
                    v-model="form[field.labelField]"
                    v-for="dic in dictionaryDataMap.get(field.labelField)"
                    v-if="field.fieldType == 'radio'"
                  >
                    {{ dic.dictLabel }}
                  </el-radio>

                  <el-checkbox-group
                    style="width: 100%"
                    @change="$forceUpdate()"
                    v-model="form[field.labelField]"
                    :disabled="disabledFalg"
                    v-if="field.fieldType == 'checkbox'"
                  >
                    <el-checkbox
                      v-for="city in dictionaryDataMap.get(field.labelField)"
                      :label="city.dictValue"
                      :key="city.dictCode"
                      >{{ city.dictLabel }}</el-checkbox
                    >
                  </el-checkbox-group>

                  <el-select
                    style="width: 100%"
                    filterable
                    :disabled="disabledFalg"
                    v-model="form[field.labelField]"
                    placeholder="请选择省/直辖市"
                    @change="getArea(2, form[field.labelField], true)"
                    v-if="field.fieldType == 'provinceId'"
                  >
                    <el-option
                      v-for="item in provOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width: 100%"
                    filterable
                    :disabled="disabledFalg"
                    v-model="form[field.labelField]"
                    no-data-text="请先选择省"
                    placeholder="请选择市/区"
                    @change="getArea(3, form[field.labelField], true)"
                    v-if="field.fieldType == 'cityId'"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width: 100%"
                    filterable
                    :disabled="disabledFalg"
                    v-model="form[field.labelField]"
                    @change="$forceUpdate()"
                    no-data-text="请先选择市"
                    placeholder="请选择区县"
                    v-if="field.fieldType == 'districtId'"
                  >
                    <el-option
                      v-for="item in countyOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="24" :key="index" v-for="(teamIndex, index) in formList">
          <div style="text-align: right" :style="{ width: labelWidth }">
            <el-tag style="cursor: pointer" effect="dark" type=""
              >{{ dictData.dictLabel }}{{ index + 1 }}</el-tag
            >
          </div>
          <el-form
            align="center"
            ref="teamForm"
            :model="items[index]"
            :rules="rules"
            :label-width="PcOrPhone == 'Phone' ? '' : labelWidth"
          >
            <el-col
              style="text-align: left"
              :span="12"
              :key="field.id"
              v-for="field in fieldNameOptions"
              v-if="field.labelField !='team_member_code'"
            >
              <el-form-item :label="field.labelName" :prop="field.labelField">
                <el-input
                  :disabled="disabledFalg"
                  v-model="items[index][field.labelField]"
                  :placeholder="
                    field.remark ? field.remark : '请输入' + field.labelName
                  "
                  v-if="
                    field.fieldType == 'input' ||
                    field.fieldType == 'linkEmail' ||
                    field.fieldType == 'linkPhone'
                  "
                />
                <el-input
                  :disabled="disabledFalg"
                  type="textarea"
                  :rows="2"
                  :placeholder="
                    field.remark ? field.remark : '请输入' + field.labelName
                  "
                  v-model="items[index][field.labelField]"
                  v-if="field.fieldType == 'textarea'"
                ></el-input>
                <el-select
                  @change="$forceUpdate()"
                  filterable
                  :disabled="disabledFalg"
                  v-model="items[index][field.labelField]"
                  :placeholder="
                    field.remark ? field.remark : '请选择' + field.labelName
                  "
                  v-if="field.fieldType == 'select'"
                >
                  <el-option
                    :key="dic.dictCode"
                    :label="dic.dictLabel"
                    :value="dic.dictValue"
                    v-for="dic in dictionaryDataMap.get(field.labelField)"
                  >
                  </el-option>
                </el-select>
                <el-radio
                  @change="number(dic)"
                  :disabled="dic.dictType == 'work_type' ? radioFalg : disabledFalg"
                  :key="dic.dictCode"
                  :label="dic.dictValue"
                  v-model="items[index][field.labelField]"
                  v-for="dic in dictionaryDataMap.get(field.labelField)"
                  v-if="field.fieldType == 'radio'"
                >
                  {{ dic.dictLabel }}
                </el-radio>

                <el-checkbox-group
                  style="width: 100%"
                  @change="$forceUpdate()"
                  :disabled="disabledFalg"
                  v-model="items[index][field.labelField]"
                  v-if="field.fieldType == 'checkbox'"
                >
                  <el-checkbox
                    v-for="city in dictionaryDataMap.get(field.labelField)"
                    :label="city.dictValue"
                    :key="city.dictCode"
                    >{{ city }}</el-checkbox
                  >
                </el-checkbox-group>

                <el-select
                  style="width: 100%"
                  filterable
                  :disabled="disabledFalg"
                  v-model="items[index][field.labelField]"
                  placeholder="请选择省/直辖市"
                  @change="
                    getTearmArea(2, items[index][field.labelField], true, index)
                  "
                  v-if="field.fieldType == 'provinceId'"
                >
                  <el-option
                    v-for="item in provOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  style="width: 100%"
                  filterable
                  :disabled="disabledFalg"
                  v-model="items[index][field.labelField]"
                  no-data-text="请先选择省"
                  placeholder="请选择市/区"
                  @change="
                    getTearmArea(3, items[index][field.labelField], true, index)
                  "
                  v-if="field.fieldType == 'cityId'"
                >
                  <el-option
                    v-for="item in cityOptionsList[index]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  style="width: 100%"
                  filterable
                  :disabled="disabledFalg"
                  v-model="items[index][field.labelField]"
                  @change="$forceUpdate()"
                  no-data-text="请先选择市"
                  placeholder="请选择区县"
                  v-if="field.fieldType == 'districtId'"
                >
                  <el-option
                    v-for="item in countyOptionsList[index]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <div v-if="submitFalg">
        <div
          slot="footer"
          class="dialog-footer"
          style="margin-left: 200px"
          v-if="dataWaitFalg"
        >
          <el-button
            :disabled="submitFormFalg"
            v-if="!disabledFalg"
            type="primary"
            @click="submitForm"
            >确 定</el-button
          >
          <el-button @click="cancel">返 回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addData, updateData, listSysArea } from '@/api/registerForm'
import { getDicts } from '../../../api/registerForm'
import { listDivision, getdivision } from '../../../api/division/division'

export default {
  name: 'registerComponents',
  props: [
    'form',
    'siteId',
    'fieldNameOptions',
    'disabledFalg',
    'userFalg',
    'submitFalg',
    'dictData'
  ],
  data () {
    return {
      // 队员显示状态
      radioFalg: false,
      addStatus: true,
      cutStatus: true,
      teamMember: 0,
      submitFormFalg: false,
      queryDivision: false,
      divisionList: [],
      labelWidth: '200px',
      formList: [],
      items: [],
      dataWaitFalg: true,
      dictionaryDataMap: {},
      userList: [],
      // 查询参数
      queryParams: {
        siteId: undefined
      },
      idType: [],
      provOptions: [], // 省下拉
      cityOptions: [], // 市下拉
      cityOptionsList: [],
      countyOptions: [], // 区下拉
      countyOptionsList: [],
      regularDicts: [],
      regularDictsMap: {},
      PcOrPhone: '',
      PcOrPhoneStyle: '',
      rules: {
        status: [
          { required: true, message: '请选择报名类型', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '请选择报名用户', trigger: 'blur' }
        ],
        divisionId: [
          { required: true, message: '请选择赛区', trigger: 'blur' }
        ],
        CompetitionProject: [
          { required: true, message: '请选择参赛项目', trigger: 'blur' }
        ]
      },
      rule: {
        status: [
          { required: true, message: '请选择报名类型', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '请选择报名用户', trigger: 'blur' }
        ],
        divisionId: [
          { required: true, message: '请选择赛区', trigger: 'blur' }
        ],
        CompetitionProject: [
          { required: true, message: '请选择参赛项目', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 此处添加必填项的红点提示，表单生成之后再渲染没有此规则
    this.fieldNameOptions.forEach((item) => {
      if (!this.form[item.labelField]) {
        if (item.fieldType === 'linkPhone') {
          if (this.$store.state.user.phonenumber) {
            this.form[item.labelField] = this.$store.state.user.phonenumber
          }
        }
        if (item.fieldType === 'linkEmail') {
          if (this.$store.state.user.email) {
            this.form[item.labelField] = this.$store.state.user.email
          }
        }
        if (item.fieldType === 'checkbox') {
          this.form[item.labelField] = this.form[item.labelField] || []
        }
      }
      if (item.required) {
        this.rules[item.labelField] = [
          {
            required: true,
            message: item.labelName + '不能为空',
            trigger: 'blur'
          }
        ]
        if (!item.fieldType !== 'division') {
          this.queryDivision = true
        }
      }
    })
    if (!this.form.status) {
      this.form.status = '0'
    }
    this.getAreaData()
    // 查询省
    listSysArea(this.systemURL, {
      parentId: null,
      levelType: 1
    }).then((res) => {
      this.provOptions = res.rows
    })

    this.initForm()
    if (this.$route.query.id) {
      this.radioFalg = true
      this.addStatus = false
      this.cutStatus = false
    }
  },
  mounted () {
    this.$forceUpdate()
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (flag) {
      this.PcOrPhone = 'Phone'
      this.PcOrPhoneStyle = '24'
    } else {
      this.PcOrPhone = 'pc'
      this.PcOrPhoneStyle = '12'
    }
  },
  methods: {
    number (obj) {
      if (obj.dictType === 'work_type') {
        /*  //改变参赛项目清除队员信息
        if(this.teamMember ==1 || this.teamMember ==3 ){
          if(obj.dictValue == 2){
            this.clearMenber();
          }
        }else{
            this.clearMenber();
        } */
        this.teamMember = obj.dictValue
        this.$emit('project', obj.dictValue)
      }
    },
    changeDivision (val) {
      // 根据ID查询本赛区的报名开始和截止时间
      getdivision(this.siteURL, val).then(res => {
        this.divisionList.forEach((division) => {
          if (val === division.id) {
            // 获取时间跟当前时间进行对比 超过当前时间或没到当前时间不允许进行报名
            let currentTime = Date.parse(new Date())
            // 格式化设置的时间
            // 开始时间
            let applyStartDate = Date.parse(division.applyStartTime)
            // 结束时间
            let applyEndDate = Date.parse(division.applyFinishTime)
            if (currentTime <= applyStartDate) {
              this.$message({
                message: '本赛区报名未开始',
                type: 'warning'
              })
              this.disabledFalg = false
              this.$emit('startAndEndDate', false)
            } else if (currentTime >= applyEndDate) {
              this.$message({
                message: '本赛区报名已截止',
                type: 'warning'
              })
              this.$emit('startAndEndDate', false)
            } else {
              this.$emit('startAndEndDate', true)
            }
            listSysArea(this.systemURL, {
              parentId: division.areaAry[0],
              levelType: 2
            }).then((res) => {
              this.cityOptions = res.rows
            })
            this.$set(this.form, 'provinceIds', Number(division.areaAry[0]))
          }
        })
      })
      this.form.divisionId = val
    },
    // 清除队员信息
    clearMenber () {
      this.form.playerOneName = ''
      this.form.playerOneSex = ''
      this.form.playerOnePhonenumber = ''
      this.form.playerOneSchool = ''
      this.form.playerOneGrade = ''
      this.form.playerTwoName = ''
      this.form.playerTwoSex = ''
      this.form.playerTwoPhonenumber = ''
      this.form.playerTwoSchool = ''
      this.form.playerTwoGrade = ''
    },
    addForm () {
      let workTypeNumber = parseInt(document.getElementById('member').value)
      if (workTypeNumber == 0) {
        alert('请选择参赛项目')
        return
      }
      if (!this.items) this.items = []
      let child = {}
      this.cityOptionsList.push([])
      this.countyOptionsList.push([])
      this.fieldNameOptions.forEach((field, index) => {
        if (field.show) {
          if (field.fieldType == 'linkPhone') {
            child[field.labelField] = this.$store.state.user.phonenumber
          }
          if (field.fieldType == 'linkEmail') {
            child[field.labelField] = this.$store.state.user.email
          }
        }
      })
      this.items.push({})
      this.formList.push(0)
      if (workTypeNumber == this.formList.length) {
        this.addStatus = false
      }
    },
    cutForm () {
      this.formList.splice(this.formList.length - 2, 1)
      this.items.splice(this.formList.length - 2, 1)
      this.cityOptionsList.splice(this.formList.length - 2, 1)
      this.countyOptionsList.splice(this.formList.length - 2, 1)
      var workTypeNumber = parseInt(document.getElementById('member').value)
      if (this.formList.length < workTypeNumber) {
        this.addStatus = true
      }
    },
    getAreaData () {
      let pid
      let cid
      console.log(13)
      for (let val of this.fieldNameOptions) {
        if (val.fieldType == 'provinceId') {
          pid = val.labelField
        }
        if (val.fieldType == 'cityId') {
          cid = val.labelField
        }
      }
      if (this.form[pid]) {
        listSysArea(this.systemURL, {
          parentId: this.form[pid],
          levelType: 2
        }).then((res) => {
          this.cityOptions = res.rows
        })
      }
      if (this.form[cid]) {
        listSysArea(this.systemURL, {
          parentId: this.form[cid],
          levelType: 3
        }).then((res) => {
          this.countyOptions = res.rows
        })
      }
    },
    initForm () {
      if (this.queryDivision) {
        // 查询此站点的赛区信息
        listDivision(this.siteURL, {
          siteId: this.siteId
        }).then((res) => {
          this.divisionList = res.rows
          this.$forceUpdate()
        })
      } else {
        this.form.divisionId = 0
      }
      // 查询所有表单用到的字典数据
      let map = new Map()
      this.fieldNameOptions.forEach((field) => {
        if (field.type) {
          getDicts(this.systemURL, field.type).then((res) => {
            map.set(field.labelField, res.data)
            this.$forceUpdate()
            /*  if(field.type == "work_type"){
              this.cities = res.data
            } */
          })
        }
      })
      this.dictionaryDataMap = map
      // 查询表单验证规则
      getDicts(this.systemURL, 'regular_type').then((res) => {
        this.regularDicts = res.data
        // 将验证规则存如map
        this.regularDictsMap = new Map()
        this.regularDicts.forEach((item) => {
          this.regularDictsMap.set(item.dictCode, item)
        })
        if (this.form.status == '1') {
          if (this.form[this.dictData.dictCode + 'child']) {
            this.items = [...this.form[this.dictData.dictCode + 'child']]
            this.items.forEach((item) => {
              this.formList.push(0)
            })
          }
        }
        this.getFormData()
      })
    },
    // 获取所有用户
    getlistUserAll () {
      listUserAll('01').then((res) => {
        this.userList = res.data
      })
    },
    // 强制更新页面数据，循环表单数据层级过深，需要手动更新数据
    forcingUpdate () {
      this.$forceUpdate()
    },
    // 动态生成表单验证规则
    getFormListVerify () {
      // 根据站点id查询表单配置信息
      this.queryParams.siteId = this.siteId
      let that = this
      if (this.fieldNameOptions.length == 0) {
        this.dataWaitFalg = true
        this.$emit('loading', false)
      } else {
        this.fieldNameOptions.forEach((verify) => {
          if (verify.regular) {
            let rulesAry = []
            // 将字典code切分成数组，数据库存储结构是字符串类似1，2，3，4
            verify.regular.split(',').forEach((v) => {
              if (v) {
                // 封装验证
                rulesAry.push({
                  validator: (rule, value, callback) => {
                    let regular = that.regularDictsMap.get(parseInt(v))
                    if (regular) {
                      if (verify.required) {
                        if (!value) {
                          return callback(
                            new Error(verify.labelName + '不能为空')
                          )
                        } else {
                          // 正则校验
                          if (!new RegExp(regular.dictValue).test(value)) {
                            return callback(new Error(regular.remark))
                          } else {
                            // 数据校验成功，放行
                            return callback()
                          }
                        }
                      } else {
                        if (!value) {
                          // 不是必填但是有校验规则，只在有值的情况下就行规则校验
                          return callback()
                        } else {
                          // 正则校验
                          if (!new RegExp(regular.dictValue).test(value)) {
                            return callback(new Error(regular.remark))
                          } else {
                            // 数据校验成功，放行
                            return callback()
                          }
                        }
                      }
                    } else {
                      // 没有校验规则直接放行
                      return callback()
                    }
                  },
                  trigger: 'blur'
                })
              }
            })
            if (this.rule[verify.labelField]) {
              this.rule[verify.labelField].concat(rulesAry)
            } else {
              this.rule[verify.labelField] = rulesAry
            }
          }
          this.dataWaitFalg = true
          this.$nextTick(() => {
            this.$emit('loading', false)
          })
        })
        console.log('====this.rule==============')
        console.log(this.rule)
        console.log('====this.rule==============')
        console.log('====this.rules==============')
        console.log(this.rules)
        console.log('====this.rules==============')
        this.rules = this.mergeObjectsWithAppend(this.rules, this.rule)
        // 强制重新校验
        this.$nextTick(() => {
          this.$refs.form.clearValidate(); // 清除校验状态
        });
        console.log('====this.rules---new==============')
        console.log(this.rules)
        console.log('====this.rules---new==============')
      }
    },
    mergeObjectsWithAppend(obj1, obj2) {
      const merged = { ...obj1 }; // 复制 obj1 的所有属性到 merged
      for (const key in obj2) {
        if (obj2.hasOwnProperty(key)) {
          if (merged.hasOwnProperty(key)) {
            // 如果 merged 中已有该属性，检查其值是否为数组
            if (Array.isArray(merged[key])) {
              // 如果已是数组，直接追加 obj2 中的值（无论是否为数组都展开）
              merged[key] = [...merged[key], ...(Array.isArray(obj2[key]) ? obj2[key] : [obj2[key]])];
            } else if (Array.isArray(obj2[key])) {
              // 如果 merged 中不是数组但 obj2 中是数组，将 merged 中的值作为数组的第一个元素，然后追加 obj2 中的值
              merged[key] = [merged[key], ...obj2[key]];
            } else {
              // 如果两者都不是数组，将值转换为一个数组
              merged[key] = [merged[key], obj2[key]];
            }
          } else {
            // 如果 merged 中没有该属性，直接赋值
            merged[key] = obj2[key];
          }
        }
      }
      return merged;
    },
    // 取消按钮
    cancel () {
      this.$emit('back', false)
    },
    // 表单校验
    formVerify () {
      console.log('form', this.form)
      let falg = false
      this.$refs['form'].validate((valid) => {
        if (valid) {
          falg = true
        } else {
          this.$message.error('请填写完整信息')
        }
      })
      let falgNum = 0
      this.formList.forEach((item, index) => {
        this.$refs['teamForm'][index].validate((valid) => {
          if (valid) {
            falgNum++
          }
        })
      })
      if (falg && falgNum == this.formList.length) {
        this.form[this.dictData.dictCode + 'child'] = this.items
        this.$emit('formVerify', true)
      } else {
        this.$emit('formVerify', false)
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      let falg = false
      this.$refs['form'].validate((valid) => {
        if (valid) {
          falg = true
        }
      })
      if (falg) {
        this.form.siteId = this.siteId
        this.form.status = this.form.status
        this.form.userId = this.$store.state.user.userId
        let formData = {}
        this.fieldNameOptions.forEach((field) => {
          formData[field.labelField] = this.form[field.labelField]
        })
        this.form.data = JSON.stringify(formData)
        this.submitFormFalg = true
        if (this.form.id != undefined) {
          updateData(this.baseURL, this.form)
            .then((response) => {
              if (response.code === 200) {
                this.$message.success('修改成功')
                this.cancel()
              }
            })
            .catch((e) => {
              this.submitFormFalg = false
            })
        } else {
          addData(this.baseURL, this.form)
            .then((response) => {
              if (response.code === 200) {
                this.$message.success('新增成功')
                this.cancel()
              }
            })
            .catch((e) => {
              this.submitFormFalg = false
            })
        }
      }
    },
    getFormData () {
      if (this.form.id) {
        if (this.form.siteId) {
          this.getFormListVerify()
        }
      } else {
        this.getFormListVerify()
      }
    },
    getTearmArea (type, parentId, falg, index) {
      var params = {
        parentId: parentId,
        levelType: type
      }
      if (falg) {
        if (type == 2) {
          this.items[index].cityId = ''
          this.items[index].districtId = ''
        } else if (type == 3) {
          this.items[index].districtId = ''
        }
      }
      listSysArea(this.systemURL, params).then((res) => {
        if (type == 2) {
          this.cityOptionsList[index] = res.rows
        } else if (type == 3) {
          this.countyOptionsList[index] = res.rows
        }
        this.$forceUpdate()
      })
    },
    getArea (type, parentId, falg) {
      var params = {
        parentId: parentId,
        levelType: type
      }
      if (falg) {
        if (type == 2) {
          this.form.cityId = ''
          this.form.districtId = ''
        } else if (type == 3) {
          this.form.districtId = ''
        }
      }
      listSysArea(this.systemURL, params).then((res) => {
        if (type == 1) {
          this.provOptions = res.rows
        } else if (type == 2) {
          this.cityOptions = res.rows
        } else if (type == 3) {
          this.countyOptions = res.rows
        }
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped>
.regTypeTitle {
  padding-left: 120px;
}

@media screen and (max-width: 1200px) {
  .regTypeTitle {
    padding-left: 0px;
    padding-top: 5px;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-radio {
    margin-right: 55px;
    margin-bottom: 15px;
  }
}
</style>>



// WEBPACK FOOTER //
// src/views/my/form/registerComponents.vue